import { getRegExp } from 'korean-regexp';

function defaultSearchFilter(value, searchKeyword, keywords) {
  const searchKeywordRegExp = getRegExp(searchKeyword, { ignoreSpace: true });
  if (keywords === void 0 || keywords.length === 0) {
    return searchKeywordRegExp.test(value) ? 1 : 0;
  }
  return keywords.some((keyword) => searchKeywordRegExp.test(keyword)) ? 1 : 0;
}

export { defaultSearchFilter };
//# sourceMappingURL=default-search-filter.mjs.map
